export var phoneRegEx = process.env.VM_MARKET === "SG" ? /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{4}\\)[ \\-]*)|([0-9]{4})[ \\-]*)*?[0-9]{4}?[ \\-]*[0-9]{4}?$/ : /^0[23478]\d{8}$/;
// : /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// Accurate payment details derived from the BigCommerce Order Transactions API
// (GET /v3/orders/{order_id}/transactions). Unlike the lossy `payment_method`
// string, this preserves card brand/last-4, wallet vs card, gift cert, etc.

// ─────────────────────────────────────────────────────────────────────────────
// AddressFinder Types
// ─────────────────────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────────────────────
// Analytics Types
// ─────────────────────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────────────────────
// Window Augmentations
// ─────────────────────────────────────────────────────────────────────────────